"use client"
import { useEffect, useRef } from "react"
import 'bootstrap/dist/css/bootstrap.min.css';
import {  Star,  } from "lucide-react"
import "./About.css"
const AboutPage = () => {
  const aboutHeroRef = useRef(null)
  const aboutStatsRef = useRef(null)


  const stats = [
    { number: "200+", label: "Happy Customers" },
    { number: "20+", label: "Restaurant Partners" },
    { number: "51+", label: "Orders Delivered" },
    { number: "4.5", label: "Average Rating" },
  ]

  useEffect(() => {
    // Intersection Observer for scroll animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: "-50px 0px",
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("about-animate-in")
        }
      })
    }, observerOptions)

    // Observe elements
    const elementsToObserve = document.querySelectorAll(".about-scroll-reveal")
    elementsToObserve.forEach((el) => observer.observe(el))

    // Stats counter animation
    const animateStats = () => {
      const statNumbers = document.querySelectorAll(".about-stat-number")
      statNumbers.forEach((stat, index) => {
        const target = Number.parseInt(stat.dataset.target)
        const increment = target / 100
        let current = 0
  

        const timer = setInterval(() => {
          current += increment
          if (current >= target) {
            current = target
            clearInterval(timer)
          }

          if (stat.dataset.suffix) {
            stat.textContent = Math.floor(current) + stat.dataset.suffix
          } else {
            stat.textContent = Math.floor(current).toLocaleString()
          }
        }, 20)
      })
    }

    // Trigger stats animation when stats section is visible
    const statsObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateStats()
          statsObserver.unobserve(entry.target)
        }
      })
    }, observerOptions)

    if (aboutStatsRef.current) {
      statsObserver.observe(aboutStatsRef.current)
    }

    // Cleanup
    return () => {
      observer.disconnect()
      statsObserver.disconnect()
    }
  }, [])

  return (
    <div className="about-us-page">
      {/* Hero Section */}
      <section className="about-us-hero-section position-relative overflow-hidden">
        <div className="about-floating-element about-floating-element-1 position-absolute"></div>
        <div className="about-floating-element about-floating-element-2 position-absolute"></div>
        <div className="about-hero-grid-bg position-absolute w-100 h-40"></div>

        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <div className="about-hero-content" ref={aboutHeroRef}>
                <h1 className="about-hero-title display-1 fw-bold mb-4">Our Story</h1>
                <p className="about-hero-subtitle lead fs-3 text-muted fst-italic">
                  Where culinary artistry meets exceptional service is outdated
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

     {/* Main Content */}
      <section className="about-main-content py-5 about">
        <div className="container">
          <div className="row align-items-center gy-4">
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
              <div className="about-content">
                <h3 className="">Shaping the Future of <span className="about-highlight"> Convenience </span></h3>

                <p>
                  Welcome to <span className=""> Katchit </span>, your one-stop solution for all your food, transportation, and event
                  needs. We're a technology-driven platform dedicated to providing seamless and convenient
                  services to our customers.
                </p>

                <p>
                  Order anytime, track your delivery in real-time, and enjoy exclusive deals. Whether it's
                  lunch, dinner, or a midnight snack, we've got you covered with fast and reliable
                  service.
                </p>

                <div className="chef-signature mt-4">
                  <div className="row align-items-center">
                    <div className="col-auto">
                      <img
                        src="assets/img/restaurant/chef-1.webp"
                        className="chef-avatar rounded-circle"
                        alt="Chef Portrait"
                      />
                    </div>
                    <div className="col">
                      <p className="chef-message mb-2">
                        "Cooking is a language through which all the following properties may be expressed:
                        harmony, creativity, happiness, beauty, poetry, complexity, magic, humor,
                        provocation and culture."
                      </p>
                      <p className="chef-name">Executive Chef</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6" data-aos="zoom-in" data-aos-delay="300">
              <div className="about-image-wrapper">
                <img
                  src="assets/back.jpg"
                  className="img-fluid main-image shadow"
                  alt="Restaurant Interior"
                />
                <img
                  src="assets/back.jpg"
                  className="img-fluid accent-image shadow"
                  alt="Chef Preparing Food"
                />
  
                  {/* Floating Badge */}
                  <div className="about-floating-badge position-absolute d-flex align-items-center justify-content-center rounded-circle">
                    <Star className="about-badge-icon text-white" size={32} fill="currentColor" />
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-section py-5 about">
  <div className="container">
    <div className="row text-center">
      <div className="col-md-3 mb-4">
        <div className="feature-box">
          <div className="feature-icon">
            <i class="bi bi-fork-knife"></i>
          </div>
          <h4>Wide Restaurant Selection</h4>
          <p>Michelin Star Partners</p>
        </div>
      </div>

      <div className="col-md-3 mb-4">
        <div className="feature-box">
          <div className="feature-icon">
<i class="bi bi-geo-alt"></i>
          </div>
          <h4>Live Order Tracking</h4>
          <p>Real-time Updates</p>
        </div>
      </div>

      <div className="col-md-3 mb-4">
        <div className="feature-box">
          <div className="feature-icon">
<i class="bi bi-lightning-charge-fill"></i>
          </div>
          <h4>Fast & Reliable</h4>
          <p>30min Delivery</p>
        </div>
      </div>

      <div className="col-md-3 mb-4">
        <div className="feature-box">
          <div className="feature-icon">
      <i class="bi bi-lock"></i>
          </div>
          <h4>Secure Payment</h4>
          <p>100% Protected</p>
        </div>
      </div>
    </div>
  </div>
</section>
      {/* Stats Section */}
      <section className="about-stats-section py-5 text-white" ref={aboutStatsRef}>
        <div className="container">
          <div className="row g-4 text-center">
            {stats.map((stat, index) => (
              <div key={index} className="col-6 col-md-3">
                <div className="about-stat-item about-scroll-reveal" style={{ animationDelay: `${index * 0.1}s` }}>
                  <div
                    className="about-stat-number display-2 fw-bold mb-2"
                    data-target={stat.number.replace(/[^0-9.]/g, "")}
                    data-suffix={stat.number.includes("+") ? "+" : ""}
                  >
                    0
                  </div>
                  <div className="about-stat-label fs-6 fw-medium opacity-75">{stat.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="about-cta-section py-5 bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <div className="about-cta-content about-scroll-reveal">
                <h3 className="about-cta-title display-4 fw-bold mb-4">Ready to Experience the Difference?</h3>
                <p className="about-cta-text fs-5 text-muted mb-4 lh-base">
                  Join thousands of satisfied customers who trust us for their daily meals.
                </p>
                <button className="about-cta-button btn btn-lg px-5 py-3 fw-semibold fs-5 rounded-pill position-relative overflow-hidden">
                  Order Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

    
    </div>
  )
}

export default AboutPage
